export const spaceUnbreakable = '\u00a0';
export const quoteMarkOpenFrench = '«';
export const quoteMarkCloseFrench = '»';
